export enum EnumEstadoViajeOpLogistica {
  Pendiente = 1,
  Anulado,
  NoViable,
  Viable,
  Rechazado,
  Registrado,
  Programado,
  PendienteAnulacion,
  RechazadoAnulado,
  Validado
}
